import { render, staticRenderFns } from "./Drag.vue?vue&type=template&id=6c0a7a1a&scoped=true&lang=pug&"
import script from "./Drag.vue?vue&type=script&lang=js&"
export * from "./Drag.vue?vue&type=script&lang=js&"
import style0 from "@components/Drag/Drag.styl?vue&type=style&index=0&id=6c0a7a1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a7a1a",
  null
  
)

export default component.exports